import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { generateId } from '@local/common-web';

@UntilDestroy()
@Component({
  selector: 'wiki-card-compare-version',
  templateUrl: './wiki-card-compare-version.component.html',
  styleUrl: './wiki-card-compare-version.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WikiCardCompareVersionComponent {
  readonly READONLY_FRAME_EDITOR_ID = `readonly_unleash_editor_${generateId()}`;

  @Input() html: string;
}
